module.exports = __webpack_public_path__ + "static/media/longMoan.a9f8deb3.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/longMoan.mp3
// module id = 513
// module chunks = 0